import { JSX } from 'react'

import { IconProps } from '../../icon'

const Add: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 24C8 23.0181 8.79595 22.2222 9.77778 22.2222H38.2222C39.2041 22.2222 40 23.0181 40 24C40 24.9819 39.2041 25.7778 38.2222 25.7778H9.77778C8.79595 25.7778 8 24.9819 8 24Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.9999 8C24.9818 8 25.7777 8.79595 25.7777 9.77778V38.2222C25.7777 39.2041 24.9818 40 23.9999 40C23.0181 40 22.2222 39.2041 22.2222 38.2222V9.77778C22.2222 8.79595 23.0181 8 23.9999 8Z'
      fill='black'
    />
  </svg>
)

export default Add
